const casesSearchInit = (search: HTMLElement) => {
  const searchForm:HTMLFormElement = search.querySelector('.cases-search__form');
  const input = search.querySelector('input[type="text"]');
  const selects = search.querySelectorAll('select');
  let timer: any;

  input.addEventListener('keyup', () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      searchForm.submit();
    }, 2000);
  });

  selects.forEach((select) => {
    select.addEventListener('change', () => {
      searchForm.submit();
    });
  });
};

export default casesSearchInit;
